<template class="form-dados-cadastrais">
  <div class="wrapper">
  <v-form ref="formEndereco" @submit.prevent v-model="validEndereco">
    <v-container class="pt-0">
      <div class="header-step">
        <h3>Endereço</h3>
        <p>Informe ou confirme o endereço do segurado.</p>
      </div>
      <v-layout row wrap>
        
        <v-flex xs12 md6>
          <v-text-field
            v-if="dadosTransportadoraCompleto.id"
            label="UF"
            disabled
            
            v-model="dadosEnderecoBusca.estado"
          ></v-text-field>
          <v-autocomplete
            v-else
            :disabled="disableEndereco" 
            v-model="dadosEndereco.uf"
            id="txtDadosCadastraisEstado"
            ref="txtDadosCadastraisEstadoRef"
            label="UF"
            :items="listaEstados"
            @blur="carregaCidadesDoEstado(dadosEndereco.uf)"
            no-data-text="Sem estados para listar"
            browser-autocomplete="off"
            item-text="sigla"
            item-value="sigla"
            :rules="regras.notNull"
          >
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm5>
          <v-text-field
          label="Cidade*"
          disabled
          v-if="dadosTransportadoraCompleto.id"
          v-model="dadosEnderecoBusca.cidade"
          ></v-text-field>
          <v-autocomplete
            v-else
            :disabled="disableEndereco"
            label="Cidade*"
            id="txtDadosCadastraisCidade"
            ref="txtDadosCadastraisCidade"
            :items="listaCidades"
            item-text="nome"
            item-value="nome"
            no-data-text="Sem cidades para listar"
            browser-autocomplete="off"
            v-model="dadosEndereco.cidade"
            :rules="regras.notNull"
          >
          </v-autocomplete>
        </v-flex>
        
      </v-layout>
      <v-layout row>
        <v-flex xs4 md3>
          <v-btn flat @click="$emit('voltarEndereco', true)" color="primary">
            Voltar
          </v-btn>
        </v-flex>
        <v-flex xs4 md3>
          <v-btn
            :disabled="!validEndereco"
            type="submit"
            @click="$emit('dadosEndereco', dadosEndereco)"
            color="primary"
          >
            proximo
          </v-btn>
        </v-flex>
      
      </v-layout>
    </v-container>
  </v-form>
</div>
</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
export default {
  name: "QAREndereco",
  props: {
    protocolo: String,
    dadosTransportadoraCompleto: {
      type: Object, 
      required: false,
    }
  },
  data: () => ({
    listaCidades: [],
    countCarregamentosCidade: 0,
    listaPaises: [],
    listaEstados: [],
    dadosEnderecoBusca: {
      estado: null, 
      cidade: null, 
    },
    validEndereco: true,
    dadosEndereco: {
      cep: null,
      endereco: [{
        id: 0,
        uf: "",
      pais: "",
      cidade: "",
      }] ,
      ufDeposito: null,
      numero: null,
      complemento: null,
      bairro: null
    },
    ufBrasil: [],
    regras: {
      notNull: [v => !!v || "Você não pode deixar este campo em branco"],
      cep: [v => !!String(v).match(/^\d{8}$/) || "CEP incorreto"]
    }
  }),
  mounted: function() {
    this.carregaPaises();
    this.carregaEstados();
  },
  watch: {
    dadosTransportadoraCompleto(value) {
      if(value.id != null  &&  value.id != undefined) {
        this.dadosEnderecoBusca.cidade = value.enderecos[0].cidade;
        this.dadosEnderecoBusca.estado = value.enderecos[0].estado;
      }
    }
  },
  computed: {
    disableEndereco() {
      return this.protocolo != null || this.dadosTransportadoraCompleto.id != null;
    },
  },
  methods: {
    getUfList() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/enderecoUf`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.ufBrasil = response.data;
        })
        .catch(err => {
          console.error(err);
        });
    },
    carregaCidadesDoEstado: function(estadoParam) {
      const self = this;

      if (estadoParam && estadoParam != "") {
        if (
          self.dadosEndereco.cidade != "" &&
          self.countCarregamentosCidade > 1
        ) {
          self.dadosEndereco.cidade = "";
        }

        const estadoSelecionado = self.listaEstados.find(estado => {
          return estado.sigla == estadoParam;
        });

        axios

          .get(
            `${process.env.URL_GEOMS}/v1/no-auth/buscaCidadesDeUmEstado?idestado=${estadoSelecionado.id}`
          )

          .then(response => {
            self.listaCidades = response.data;

            self.countCarregamentosCidade++;
          })

          .catch(error => {
            self.snackbarSalvarTransportadora.mensagem =
              error.response.data.message;

            self.snackbarSalvarTransportadora.sucesso = false;

            self.snackbarSalvarTransportadora.visivel = true;

            self.loadingSalvar = false;
          });
      }
    },
    carregaEstados: function() {
      const self = this;

       axios

        .get(`${process.env.URL_GEOMS}/v1/no-auth/buscaTodosEstadosSemDiversos`)

        .then(response => {
          self.listaEstados = response.data;
        })
    },
    carregaPaises: async function() {
      const self = this;

      await axios

        .get(`${process.env.URL_GEOMS}/v1/no-auth/buscaTodosPaises`)

        .then(response => {
          self.listaPaises = response.data;
        });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/pages/questionario-analise-riscos/steps/QAREndereço.vue